import React from 'react';
import { Select } from '../ui/Select';
export function AccountsTab() {
  return <div className="space-y-6 max-w-4xl animate-in fade-in slide-in-from-bottom-4 duration-500" data-id="element-497">
      <div className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm" data-id="element-498">
        <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-499">
          GL Account Configuration
        </h3>
        <p className="text-sm text-gray-500 mb-6" data-id="element-500">
          Select the General Ledger account for this loan product.
        </p>

        <div className="max-w-md" data-id="element-501">
          <Select label="GL Account" required options={[{
          value: '',
          label: 'Select GL Account...'
        }, {
          value: 'gl_1000',
          label: 'GL-1000 - Loan Receivables'
        }, {
          value: 'gl_2000',
          label: 'GL-2000 - Interest Income'
        }, {
          value: 'gl_3000',
          label: 'GL-3000 - Fee Income'
        }, {
          value: 'gl_4000',
          label: 'GL-4000 - Penalty Income'
        }]} helperText="This account will be used for all transactions related to this product" data-id="element-502" />
        </div>
      </div>
    </div>;
}